import { css, html } from 'lit'
import HHQuizElement from '../element.js'

/**
 * Summary view
 * @extends
 */
class HHQuizGeorgiasWidget extends HHQuizElement {

  toggleChat(open = true) {
    if (!window.GorgiasChat) {
      if (open) alert('No georgias chat found')
      return;
    }
    document.getElementById('gorgias-chat-container').style.cssText = `display:${open ? 'block' : 'none'} !important`
    if (open) setTimeout(() => GorgiasChat.open(), 0); else GorgiasChat.close()
  }

  disconnectedCallback() {
    this.toggleChat(false)
    super.disconnectedCallback()
  }

  /**
   * Renders the current route
   * @returns {TemplateResult}
   */
  render() {
    return html`
      <div class="hh-quiz-georgias-widget">
        <div class="container">
          <h3 class="h6">${HH_QUIZ.t.georgias_widget.title}</h3>
          <h3 class="h2">${HH_QUIZ.t.georgias_widget.title}</h3>
          <p class="body">${HH_QUIZ.t.georgias_widget.message}</p>
          <hh-button
            @keydown="${(ev) => ev.stopPropagation()}"
            @click="${() => this.toggleChat(true)}"
            theme="secondary-negative">
              ${HH_QUIZ.t.georgias_widget.button}
          </hh-button>
        </div>
      </div>
    `
  }

  static styles = [
    HHQuizElement.styles,
    css`
      .hh-quiz-georgias-widget {
        background: var(--hh-color-aged-black);
        padding: 60px 20px;
        text-align: center;
      }

      .hh-quiz-georgias-widget,
      .hh-quiz-georgias-widget * {
        color: var(--hh-color-sundrenched-stone);
      }

      .h6,
      .h2 {
        margin-bottom: 10px;
      }

      .h2 {
        display:none;
      }

      .body {
        margin-bottom: 40px;
      }

      @media screen and (max-width: ${HHQuizElement.mq.sm}px) {
        .h6 {
          display: none;
        }

        .h2 {
          display: block;
        }
      }
    `,
  ]
}

customElements.define('hh-quiz-georgias-widget', HHQuizGeorgiasWidget)
